import React, { useEffect } from "react";
import firebase from "../../firebase";
import { useNavigate } from "react-router-dom";
export default function Check() {
  const navigate = useNavigate();

  useEffect(() => {
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        if (user.uid == "Gw9SzYHiVlVQ9LOBIJY2kBf7MUP2") {
          console.log(user.uid);
          return;
        } else {
          firebase
            .auth()
            .signOut()
            .then(function () {
              navigate("/Admin_login");
            });
        }
      } else {
        firebase
          .auth()
          .signOut()
          .then(function () {
            navigate("/Admin_login");
          });
      }
    });
  }, []);

  return null;
}
